import utility from '@/mixins/utility'

class Group {

  #data = {}

  #domains = []

  #users = []

  constructor(data={})
  {
    this.#data = data

    if( data.users )
      this.#users = utility.methods.mapModels(data.users, 'user')

    if( data.domains )
      this.#domains = utility.methods.mapModels(data.domain, 'domain')
  }

  /**
   * Property getters.
   */
  
  get active()
  {
    return this.#data.active == true
  }

  get name()
  {
    return this.#data.name
  }

  /**
   * Computed properties.
   */
  

  /**
   * Relationships.
   */
  
  get users()
  {
    return this.#users
  }

  get domains()
  {
    return this.#domains
  }


  /**
   * Methods.
   */
  

}

export default Group